const TECHNICAL_ERROR_CODES: Record<string, string> = {
  '12': 'Incorrect enumeration',
  '13': 'Missing',
  '15': 'Not supported in this position',
  '18': 'Unspecified Error / Other',
  '35': 'Too many repetitions',
  '39': 'Element too long (length constraint)',
  '40': 'Element too short (length constraint)',
  '50': 'Invalid Value for the specific type',
  '51': 'Invalid value according to the pattern',
  '52': 'Invalid XML format',
  '53': 'Invalid character(s)',
  '54': 'Value is lower than the allowed lowest limit (Minimum Inclusive)',
  '55': 'Value is greater than the allowed upper limit (Maximum Inclusive)',
  '56': 'Value is lower than or equal to the allowed lowest limit (Minimum Exclusive)',
  '57': 'Value is greater than or equal to the allowed upper limit (Maximum Exclusive)',
};

const FUNCTIONAL_ERROR_CODES: Record<string, string> = {
  '12': 'Codelist violation',
  '13': 'Condition violation (Missing)',
  '14': 'Rule violation',
  '15': 'Condition violation (Not allowed)',
  '26': 'Duplicate Message ID',
  '50': 'Transitional constraint violation',
  '51': 'EDI violation post downgrade',
  '52': 'Functional violation post downgrade',
  '90': 'Unknown MRN',
  '92': 'Message out of sequence',
  '93': 'Invalid MRN (Remark: The structure of the MRN is not conform specifications.)',
};

export const getErrorDescription = (errorType: string, errorCode: string): string => {
  if (errorType === 'technical') {
    return TECHNICAL_ERROR_CODES[errorCode] || 'N/A';
  }

  if (errorType === 'functional') {
    return FUNCTIONAL_ERROR_CODES[errorCode] || 'N/A';
  }

  return 'N/A';
};
